import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import { useHistory } from "react-router-dom";
import GMSFillButton from "../../Common/components/GMSFillButton";
import { toast } from "react-toastify";
const SettingsView = () => {
  const [disableCacheButton, setDisableCacheButton] = useState(false);
  const [disableABSButton, setDisableABSButton] = useState(false);
  const [disableScoreButton, setDisableScoreButton] = useState(false);
  const [disableCFButton, setDisableCFButton] = useState(false);
  let scoreStatus = ''
  const [loaded, setloaded] = useState(false);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const appData = useContext(AppContext);
  const history = useHistory();
  useEffect(() => {
    if (!appData.pm.checkPermission("gmssettings_edit")) {
      history.push("/workspace/module/permission/denied");
    } else {
      setloaded(true);
    }
  }, []); // eslint-disable-line
  const triggerCacheRefresh = async () => {
    setDisableCacheButton(true);
    let res = await ServiceWrapper.doGet(
      api_base_url + "masterdata/generate",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data) {
      toast.info(
        "Triggerred successfully, the button will be locked for next 7 minutes."
      );
      setTimeout(() => {
        setDisableCacheButton(false);
      }, 420000);
    } else {
      toast.error("Error Occured");
      setDisableCacheButton(false);
    }
  };

  const triggerABSfresh = async () =>{
    setDisableABSButton(true);
    let res = await ServiceWrapper.doGet(
      api_base_url + "refresh/abs",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data) {
      toast.info(
        "Triggerred successfully, the button will be locked for 1 minute."
      );
      setTimeout(() => {
        setDisableABSButton(false);
      }, 60000);
    } else {
      toast.error("Error Occured");
      setDisableABSButton(false);
    }
  }

  const triggerCFRefresh = async () =>{
    setDisableCFButton(true);
    const res = await ServiceWrapper.doGet(
      api_base_url + "refresh/cf",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data) {
      toast.info("Triggerred successfully, the button will be locked for 1 minute.");
      setTimeout(() => {
        setDisableCFButton(false);
      }, 60000);
    } else {
      toast.error("Error Occured");
      setDisableCFButton(false);
    }
  }

  async function checkScoreStatus(jobId) {
    if (jobId) {
      let ret = await ServiceWrapper.doGet(
        api_base_url + "job/status/" + jobId,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!ret.errorfound) {
        if (ret.data.processing) {
          setTimeout(() => {
            checkScoreStatus(jobId);
          }, 10000);
          if(scoreStatus !== ret.data.status){
            scoreStatus = ret.data.status;
            toast.success(ret.data.status);
          }
          return;
        }
        else{
          setDisableScoreButton(false)
        }

        if (ret.data.error) {
          toast.error(ret.data.status);
          return;
        }
      }
    } else {
      toast.error("Job Id not found");
      setDisableScoreButton(false)
    }
  }

  const triggerScorefresh = async () =>{
    setDisableScoreButton(true)
    let res = await ServiceWrapper.doGet(
      api_base_url + "refresh/score_calculation",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data && res?.data?.done) {
      let task_id = res.data.task_id
      checkScoreStatus(task_id)
    } else {
      toast.error("Error Occured");
      setDisableScoreButton(false);
    }
  }
  return (
    <>
      {loaded && (
        <>
        <div className="border-bottom ">
          <div className="d-flex justify-content-between ps-4 pe-3 pt-2 pb-2">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Settings
            </label>
          </div>
        </div>
        <div className="border-bottom ">
          <div className="d-flex justify-content-between ps-4 pe-3 pt-2 pb-2">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Cache Management
            </label>
            <GMSFillButton
              name="Trigger Cache"
              disabled={disableCacheButton}
              onClick={() => {
                triggerCacheRefresh();
              }}
            />
          </div>
        </div>
        <div className="border-bottom ">
          <div className="d-flex justify-content-between ps-4 pe-3 pt-2 pb-2">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              ABS Management
            </label>
            <GMSFillButton
              name="Trigger ABS"
              disabled={disableABSButton}
              onClick={() => {
                triggerABSfresh();
              }}
            />
          </div>
        </div>
        <div className="border-bottom ">
          <div className="d-flex justify-content-between ps-4 pe-3 pt-2 pb-2">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Score Calculation
            </label>
            <GMSFillButton
              name="Trigger Score"
              disabled={true}
              onClick={() => {
                triggerScorefresh();
              }}
            />
          </div>
        </div>
        <div className="border-bottom ">
          <div className="d-flex justify-content-between ps-4 pe-3 pt-2 pb-2">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              CF Management
            </label>
            <GMSFillButton
              name="Trigger CF"
              disabled={disableCFButton}
              onClick={() => {
                triggerCFRefresh();
              }}
            />
          </div>
        </div>
      </>
      )}
    </>
  );
};
export default SettingsView;
